var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.334473,
    width: 40,
    height: 40,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_234_5463)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_234_5463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 11,
    width: 18,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.6396H30V29.6396H12V11.6396Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_234_5463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.175 12.4829H28.9354L22.9054 19.3923L30 28.7961H24.4457L20.0923 23.0939L15.1166 28.7961H12.3536L18.8027 21.4032L12 12.4842H17.6957L21.6249 17.6952L26.175 12.4829ZM25.2043 27.1401H26.7343L16.86 14.0528H15.2194L25.2043 27.1401Z",
    fill: "#004B7E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_234_5463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 11.6396)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.93dde7b5d56b190f6bc5cab46cc43f86.svg";
export { ForwardRef as ReactComponent };